import { ContentNode } from '@helo/cms'
import { useEffect } from 'react'

import { useAppStore } from '../../store/appStore/appStore'
import {
  EMPTY_VALUE_DEFAULT,
  MULTIPLE,
  valueTransformer,
} from '../../utils/valueFormatter'
import { createWidget } from '../widget-utils'

export type BrowserTitleReporterProps = {
  contentNode?: ContentNode
  isLoading?: boolean
}

/**
 * Reports a scalar `contentNode` into the browser title slice as the detail
 * page’s primary entity display string. Prefer
 * `ViewConfig.state.browserTabTitleEntityContentNode` on the view so that string
 * resolves without an extra widget; use this for one-off or dynamic cases.
 */
export const BrowserTitleReporter = ({
  contentNode,
  isLoading,
}: BrowserTitleReporterProps) => {
  useEffect(() => {
    if (isLoading) return

    const raw =
      contentNode && 'data' in contentNode
        ? valueTransformer((contentNode as { data: unknown }).data)
        : ''
    const trimmed = raw?.trim()
    const id =
      trimmed && trimmed !== EMPTY_VALUE_DEFAULT && trimmed !== MULTIPLE
        ? trimmed
        : null

    useAppStore.getState().browserDocumentTitle.updateTitle({
      detailEntityDisplay: id,
    })

    return () => {
      useAppStore.getState().browserDocumentTitle.updateTitle({
        detailEntityDisplay: null,
      })
    }
  }, [contentNode, isLoading])

  return null
}

export const BrowserTitleReporterDefinition = createWidget(
  BrowserTitleReporter,
  {
    type: 'BrowserTitleReporter',
    manualQuery: true,
  },
)
